import React from 'react';
import { Navigate } from 'react-router-dom';
import { Auth } from './Utils/Auth';

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = Auth.isLoggedIn();

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
};

export default ProtectedRoute;